import gsap from 'gsap'

import Deferred from '@/webgl/core/Deferred'
import IAnimationTrack from '@/webgl/runner/interfaces/IAnimationTrack'
import EyeMaskRenderer from '@/webgl/runner/rendering/EyeMaskRenderer'

type EyeRevealOptions = {
  delay: number
  reverse: boolean
}

export default class EyeRevealAnimation implements IAnimationTrack {
  options: EyeRevealOptions

  public constructor(
    private eye: EyeMaskRenderer,
    options: Partial<EyeRevealOptions> = {}
  ) {
    this.options = {
      delay: 0,
      reverse: false,
      ...options,
    }
  }

  init(): void {
    this.eye.closeFactor = this.options.reverse ? 0 : 1
  }

  play(): Promise<unknown> {
    const defer = new Deferred<void>()

    this.eye.enableBlinking = false

    gsap.to(this.eye, {
      closeFactor: this.options.reverse ? 1 : 0,
      duration: 1.0,
      delay: this.options.delay,
      ease: 'power2.inOut',
      onComplete: () => {
        this.eye.enableBlinking = true
        defer.resolve()
      },
    })

    return defer.promise
  }
}
